/* global axios */
import ApiClient from './ApiClient';

class ExecutiveSummaryAPI extends ApiClient {
  constructor() {
    super('reports/executive_summary', { accountScoped: true });
  }

  getMetrics({ startDate, endDate } = {}) {
    return axios.get(this.url, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  generatePdf({ startDate, endDate } = {}) {
    return axios.post(
      `${this.url}/generate`,
      { start_date: startDate, end_date: endDate },
      { responseType: 'blob' }
    );
  }

  sendByEmail({ startDate, endDate, emails } = {}) {
    return axios.post(`${this.url}/email`, {
      start_date: startDate,
      end_date: endDate,
      emails,
    });
  }
}

export default new ExecutiveSummaryAPI();
